import React from 'react';

const Hero = () => {
  return (
    <section className="py-16 md:py-24 max-w-2xl mx-auto">
      <div className="space-y-4">
        {/* Headline: Autoridad pura y el hito del Exit */}
        <p className="font-serif text-2xl md:text-3xl text-foreground/90 leading-snug">
          Scaling the tech workforce with AI. <br />2x Founder. 1 Exit.
        </p>
        
        {/* Sub-headline: Conecta tu pasión por el diseño con la visión de infraestructura */}
        <p className="font-serif text-lg md:text-xl text-muted-foreground leading-relaxed italic">
          Bridging the gap between engineering excellence and global scale through intelligent infrastructure.
        </p>
      </div>

      <div className="mt-10 max-w-lg">
        {/* Body: Alineado con el problema del Deck (Noise Crisis) sin quemar números */}
        <p className="font-sans text-base md:text-lg text-foreground/70 leading-relaxed">
          I build companies at the intersection of <span className="font-semibold text-foreground">automated operations</span> and human-centered design. 
          After a successful exit in 2024, I founded <span className="font-semibold text-foreground"><a target="_blank" href="https://enabl.ai/">enabl.ai</a></span> to solve the 'Noise Crisis' in tech hiring, building the intelligent firewall for the global talent market.
        </p>
      </div>
      
      <div className="mt-12 flex items-center gap-4">
        <div className="flex items-center gap-2">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
          </span>
          <span className="text-xs font-mono uppercase tracking-widest text-muted-foreground">
            Building enabl.ai
          </span>
        </div>
        <span className="text-muted-foreground/30 text-xs">/</span>
        <span className="text-xs font-mono uppercase tracking-widest text-muted-foreground">
          Seed Stage
        </span>
      </div>
    </section>
  );
};

export default Hero;